import Vue from "vue";

export class AudioPreloader {
  audioDataContainer: Record<string, ArrayBuffer>;
  exerciseData: Record<any, any>;
  audioElements: Record<any, any>[];

  constructor(exerciseData: Record<any, any>, audioDataContainer: Record<string, ArrayBuffer>) {
    this.exerciseData = exerciseData;
    this.audioDataContainer = audioDataContainer;
    this.audioElements = this.extractAudioElements();
  }

  downloadAudioData = async () => {
    for (let pageIndex = 0; pageIndex < this.audioElements.length; pageIndex++) {
      const audioElement = this.audioElements[pageIndex];

      await this.downloadAudio(audioElement);
    }
  };

  downloadAudio = async (audioElement: Record<any, any>) => {
    const audioElementUrl = audioElement.url;

    const response = await fetch(audioElementUrl, { mode: "cors" });

    const arrayBuffer = await response.arrayBuffer();

    Vue.set(this.audioDataContainer, response.url, arrayBuffer);
  };

  extractAudioElements = (): Record<any, any>[] => {
    return this.exerciseData.pages.reduce(
      (accumulator: Record<any, any>[], page: Record<any, any>) => {
        accumulator.push(
          ...page.body.filter((body: Record<any, any>) => {
            return body.type === "AUDIO";
          })
        );

        return accumulator;
      },
      []
    );
  };
}
